// functions that will be required in different parts of the application and used globally, are here.

import axios from "axios";
import { Config } from "./Config";

export function handleExpiredToken() {
  let RefreshToken = window.localStorage.getItem("RefreshToken");

  var Credentials = new FormData();
  Credentials.append("refresh_token", RefreshToken);
  Credentials.append("grant_type", "refresh_token");
  var Request = {
    method: "POST",
    baseURL: window._env_.API_URL + Config.AuthBaseURL + "/oauth/token",
    headers: {
      Authorization: "Basic " + Config.IdentityToken,
    },
    data: Credentials,
  };
  axios(Request)
    .then((Res) => {
      console.log(Res);
      window.localStorage.setItem("Token", Res.data.access_token);
      window.localStorage.setItem("RefreshToken", Res.data.refresh_token);
    })
    .catch((Err) => {
      console.log(Err.response);
      if (
        Err.response.status === 401 &&
        window.localStorage.getItem("TimeoutDuration") !== "reached"
      ) {
        window.localStorage.clear();
        window.location.assign("/");
      }
    });
}

// This function is used throughout the application to display dates in the defined CX format
export function formatDate(DateValue, UniversalFormat = false) {
  // Defining the currently selected language (for displaying the correct month names)
  let ActiveLang = window.localStorage.getItem("ActiveLang");
  if (ActiveLang === null || ActiveLang === undefined) {
    ActiveLang = "EN"; // default value in case the currently selected value is not present or available
  }

  let Day = new Date(DateValue).getDate();
  let Month = new Date(DateValue).getMonth();
  let Year = new Date(DateValue).getFullYear();

  let FinalDate =
    Day + "-" + switchMonthAbbreviation(Month, ActiveLang) + "-" + Year;

  if (UniversalFormat) {
    return FinalDate
  }

  if (window.innerWidth <= 450) {
    return Day + "-" + switchMonthAbbreviation(Month, ActiveLang);
  } else {
    return FinalDate;
  }
}

function switchMonthAbbreviation(Month, ActiveLang) {
  if (ActiveLang === "EN") {
    switch (Month) {
      case 0:
        return "Jan";
      case 1:
        return "Feb";
      case 2:
        return "Mar";
      case 3:
        return "Apr";
      case 4:
        return "May";
      case 5:
        return "Jun";
      case 6:
        return "Jul";
      case 7:
        return "Aug";
      case 8:
        return "Sep";
      case 9:
        return "Oct";
      case 10:
        return "Nov";
      case 11:
        return "Dec";
    }
  } else if (ActiveLang === "DE") {
    switch (Month) {
      case 0:
        return "Jan";
      case 1:
        return "Feb";
      case 2:
        return "Mär";
      case 3:
        return "Apr";
      case 4:
        return "Mai";
      case 5:
        return "Jun";
      case 6:
        return "Jul";
      case 7:
        return "Aug";
      case 8:
        return "Sep";
      case 9:
        return "Okt";
      case 10:
        return "Nov";
      case 11:
        return "Dez";
    }
  }
}

// Translation function
export const translateText = (LabelId, LangData) => {
  // If LangData is missing/null, return ID to prevent blank screen
  if (!LangData || !Array.isArray(LangData)) {
    return LabelId || ""; 
  }

  var Filter = "label_id";
  var Keyword = LabelId;
  var Label = LangData.filter((Obj) => {
    return Obj && Obj[Filter] === Keyword;
  });

  return Label[0]?.label_value || LabelId;
};

// Convert minutes to milliseconds
export const msToMinutes = (ms) => {
  return ms / 60000;
};

// Convert milliseconds to minutes
export const minutesToMilliseconds = (mins) => {
  return mins * 60000;
};

export const displayAvailabilityDateUnitNameText = (Enum, LangData) => {
  let Items;
  if (LangData) {
    Items = [
      { name: translateText("hours_per_day", LangData), id: "HOURS_PER_DAY" },
      { name: translateText("hours_per_week", LangData), id: "HOURS_PER_WEEK" },
      { name: translateText("days_per_week", LangData), id: "DAYS_PER_WEEK" },
      { name: translateText("days_per_month", LangData), id: "DAYS_PER_MONTH" },
    ];
  } else {
    Items = [
      { name: "Hours / Day", id: "HOURS_PER_DAY" },
      { name: "Hours / Week", id: "HOURS_PER_WEEK" },
      { name: "Days / Week", id: "DAYS_PER_WEEK" },
      { name: "Days / Month", id: "DAYS_PER_MONTH" },
    ];
  }

  let Result = Items.filter((Item) => {
    return Item.id === Enum;
  });

  if (Result[0]) {
    return Result[0].name;
  }

  // return empty string if not found
  return ''
};
